module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-1.28fd1587.jpg";